import React, { useState, useEffect } from 'react';
// ИЗМЕНЕНИЕ: Убираем импорт из Firebase, он больше не нужен
// import { getSliderData } from '../firebase/sliderService'; 
import './MobileSlider.css';

const MobileSlider = () => {
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading] = useState(true);

  // 🔥 ИЗМЕНЕНИЕ: Загружаем данные из нашего локального slider.json
  useEffect(() => {
    const loadSliderData = async () => {
      try {
        setLoading(true);
        // Делаем запрос к файлу на том же сервере
        const response = await fetch('/data/slider.json');
        const data = await response.json();
        
        // Отбираем только активные слайды для показа на сайте
        setSlides(data.slides.filter(slide => slide.isActive && slide.image));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    loadSliderData();
  }, []);

  // useEffect для авто-смены (без изменений)
  useEffect(() => {
    if (slides.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 3000); 
    return () => clearInterval(interval);
  }, [slides.length]);

  // 🔥 НОВАЯ ФУНКЦИЯ: Ручное переключение слайдов при нажатии
  const handleSlideClick = () => {
    if (slides.length <= 1) return;
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };

  if (loading) { return <div className="mobile-slider-container"><div className="mobile-slider-loading"><p>Загрузка слайдера...</p></div></div>; }
  if (slides.length === 0) return null;

  return (
    <div className="mobile-slider-container">
      <div className="mobile-slider-wrapper" onClick={handleSlideClick}>
        {slides.map((slide, index) => (
          <div
            // 🔥 ВАЖНО: Вместо slide.id можно использовать index, так как id у нас временный
            key={index}
            className={`mobile-slide ${index === currentSlide ? 'active' : ''}`}
          >
            {/* 
              Эта строка работает идеально!
              slide.image содержит "/images/slide1.jpg".
              Так как сайт на aison.kz, браузер сам сделает правильный запрос:
              https://aison.kz/images/slide1.jpg
            */}
            <img src={slide.image} alt={`Slide ${index + 1}`} /> 
          </div>
        ))}
      </div>
      <div className="mobile-slider-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`mobile-slider-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Перейти к слайду ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileSlider;